import { Alert, Button, Col, Row, Space } from "antd";
import { FC, useState } from "react";
import { LogTextStatus } from "../../../../components/logText";
import SimpleCard from "../../../../components/simpleCard";
import LeasingStore from "../../../../contexts/leasingStore";
import _t from "../../../../lang/translate";
import DownloadPartnerCase from "./downloadPartnerCase";
import LeasingEquipmentReport from "./leasingEquipmentReport";
import LeasingUpdateCustomer from "./leasingUpdateCustomer";
import LeasingValidationActions from "./leasingValidationActions";
import LeasingValidationAdminInfo from "./leasingValidationAdminInfo";
import SendCreditPortalLink from "./sendCreditPortalLink";
import SendToPartnerValidation from "./sendToPartnerValidation";
import Icon from "../../../../assets/icons/icon";
import StatusTag from "../../../../components/statusTag";
import openModal from "../../../../components/modal/openModal";
import { LeasingCaseType } from "../../../../types/leasingTypes";

const LeasingAdminValidation: FC = () => {
  const { leasingCase, setLeasingCase } = LeasingStore.useContainer();
  const { unMergedCustomer, inputLocked } = leasingCase.flags;
  const { log } = leasingCase;
  const [loadingRiskAssessment, setLoadingRiskAssessment] = useState(false)

  async function handleRiskAssessment() {
    try {
      setLoadingRiskAssessment(true)
      const data = (await openModal('leasingUpdateRiskAssessment', { id: leasingCase.id })) as LeasingCaseType
      setLeasingCase(data)
    } catch (_e) { }
    finally {
      setLoadingRiskAssessment(false)
    }
  }

  return (
    <>
      <SimpleCard title={_t("customerData")}>
        {unMergedCustomer && <Alert type="warning" message={_t("msg.add_customer_to_system")} className="mb-1" />}
        <Row justify="space-between">
          <Col>
            <LeasingUpdateCustomer />
          </Col>
          <Col>
            {leasingCase.partnerCase ? (
              <Space>
                <DownloadPartnerCase />
                <SendToPartnerValidation />
              </Space>
            ) : (
              <SendCreditPortalLink />
            )}
          </Col>
        </Row>
      </SimpleCard>
      <SimpleCard title={_t("carData")}>
        <LeasingEquipmentReport />
      </SimpleCard>

      <SimpleCard className="mb-0" title={_t("validation")}>
        {(leasingCase?.flags?.validationAccepted) && (
          <Row className="mb-1" justify="space-between" align="middle">
            <Col>{_t("riskClassification")}:</Col>
            <Col>
              <Button loading={loadingRiskAssessment} className="mr-05" type="link"
                disabled={inputLocked}
                icon={<Icon name="pencil-simple" />}
                onClick={handleRiskAssessment} />
              <StatusTag size="small" status={leasingCase.riskAssessment} />
            </Col>
          </Row>
        )}
        <LogTextStatus log={log?.validationAccepted}
          defaultLabel="Afventer accept af sag"
          logLabel={_t("case", "accepted")}
          className="mb-05"
          by
        />
        {!!log?.validationRejected && (
          <LogTextStatus log={log?.validationRejected}
            logLabel={_t("case", "rejected")}
            className="mb-05"
            by
          />
        )}
        <LeasingValidationAdminInfo />
        <LeasingValidationActions />
      </SimpleCard>
    </>
  );
};

export default LeasingAdminValidation;
